module.exports = __webpack_public_path__ + "components/flag/static/square/ge-74bac1c774355e541005f6a8d296a0a6.svg";